"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// This file is autogenerated by "make react_icons", do not edit it.
const React = tslib_1.__importStar(require("react"));
const LampDesk = (props) => React.createElement("svg", { className: "lucide lucide-lamp-desk", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", ...props },
    React.createElement("path", { d: "M14 5l-3 3 2 7 8-8-7-2z" }),
    React.createElement("path", { d: "M14 5l-3 3-3-3 3-3 3 3z" }),
    React.createElement("path", { d: "M9.5 6.5L4 12l3 6M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 012 2v2H3z" }));
exports.default = LampDesk;
